import {Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges} from '@angular/core';
import {TicketObjectDto} from "../../../../../model/dto/entity/ticket-object.dto";
import {ObjectIdentifier} from "../../../../../../../core/shared/basic/object-identifier";
import {TicketViewEnum} from "../../ticket-view.enum";

@Component({
    selector: 'tm-ticket-sub-navigation-tasks',
    templateUrl: './tm-ticket-sub-navigation-tasks.component.html',
    styleUrls: ['./tm-ticket-sub-navigation-tasks.component.scss'],
    standalone: false
})
export class TmTicketSubNavigationTasksComponent implements OnInit, OnChanges, OnDestroy {

    busy: boolean;  // indicator whether the component is busy
    initialized: boolean; // indicator whether the component was initialized

    @Input() mode: string;
    @Input() processMode: boolean = false;
    @Input() fullPage: boolean = true;
    @Input() objectIdentifier: ObjectIdentifier;
    @Input() ticketObjects: TicketObjectDto[];
    @Output() changeMode: EventEmitter<TicketViewEnum> = new EventEmitter<TicketViewEnum>();


    constructor() {
    }

    ngOnInit(): void {

        this.initComponent();
        this.refreshComponent();
    }

    /**
     * Initialize Component.
     */
    initComponent() {
    }

    /**
     * Refresh Component.
     */
    refreshComponent() {
        this.initialized = true;
    }


    handleBackToTicket() {
        this.changeMode.emit(TicketViewEnum.overview)
    }

    /**
     * Process changes within Binding.
     * @param changes
     */
    ngOnChanges(changes: SimpleChanges): void {

        if (!this.initialized) {
            return;
        }

        this.refreshComponent();
    }

    /**
     * Destroy component.
     */
    ngOnDestroy(): void {

    }

}
